const PAPO_MESSAGE_BASE_URL = 'https://papo.pacoca.net/mensagem';

const PHONE_FORMATTING = /[\s().\-/\\[\]]/g;
const E164_PHONE_PATTERN = /^\+[1-9]\d{7,14}$/;
const PHONE_IN_TEXT_PATTERN = /(^|[^\w+])(\+[1-9](?:[\s().\-/\\[\]]*\d){7,14})(?![\d\w])/g;

type PhoneMessageLink = {
  displayPhone: string;
  href: string;
  placeholder: string;
};

export const getPapoMessageUrl = (phone: string): string | null => {
  const normalizedPhone = phone.replace(PHONE_FORMATTING, '');

  if (!E164_PHONE_PATTERN.test(normalizedPhone)) return null;

  return `${PAPO_MESSAGE_BASE_URL}/${normalizedPhone}`;
};

/**
 * Preserves the number shown in a post or chat message while turning explicit
 * E.164 phone numbers into Paçoca Papo message links.
 */
export const renderTextWithPhoneMessageLinks = (
  text: string,
  renderText: (value: string) => string,
): string => {
  const urls: string[] = [];
  const textWithoutUrls = text.replace(/https?:\/\/[^\s]+/g, url => {
    const placeholder = `PACOCAPAPOURL${urls.length}TOKEN`;
    urls.push(url);
    return placeholder;
  });

  const phoneLinks: PhoneMessageLink[] = [];
  let textWithPlaceholders = textWithoutUrls.replace(
    PHONE_IN_TEXT_PATTERN,
    (match, prefix: string, displayPhone: string) => {
      const href = getPapoMessageUrl(displayPhone);
      if (!href) return match;

      const placeholder = `PACOCAPAPOPHONELINK${phoneLinks.length}TOKEN`;
      phoneLinks.push({ displayPhone, href, placeholder });

      return `${prefix}${placeholder}`;
    },
  );

  urls.forEach((url, index) => {
    textWithPlaceholders = textWithPlaceholders.replace(
      `PACOCAPAPOURL${index}TOKEN`,
      url,
    );
  });

  let renderedText = renderText(textWithPlaceholders);

  phoneLinks.forEach(({ displayPhone, href, placeholder }) => {
    renderedText = renderedText.replace(
      placeholder,
      `<a href='${href}' target='_blank' rel='noopener noreferrer'>${displayPhone}</a>`,
    );
  });

  return renderedText;
};
